module.exports = __webpack_public_path__ + "static/media/p2.f0b029ff.png";